import { useTranslation } from 'react-i18next';
import type { UsePaginationReturn } from '@/shared/types/pagination';

type PaginationInfoProps = Pick<UsePaginationReturn, 'pageIndex' | 'pageSize' | 'totalItems'>;

export function PaginationInfo({ pageIndex, pageSize, totalItems }: PaginationInfoProps) {
  const { t } = useTranslation('pagination');

  if (totalItems === 0) return null;

  const from = pageIndex * pageSize + 1;
  const to = Math.min((pageIndex + 1) * pageSize, totalItems);

  return (
    <span className="hidden sm:block text-[13px] text-muted-foreground whitespace-nowrap">
      {t('showing', { from, to, total: totalItems })}
    </span>
  );
}
